import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import Usuario from "../../page/usuarios/Usuario";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const UsuarioController = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [provincias, setProvincias] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(null);
  const [filePreview, setFilePreview] = useState({
    comprobante_afip: null,
    comprobante_cbu: null,
    comprobante_entidad: null,
    comprobante_identificador: null,
  });

  const handleFilePreview = (file, fieldName) => {
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreview(prev => ({
          ...prev,
          [fieldName]: reader.result
        }));
      };
      reader.readAsDataURL(file);
    } else if (file && file.type === 'application/pdf') {
      // Para PDFs, mostramos un icono o texto indicativo
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: 'pdf'
      }));
    } else if (file) {
      // Para otros tipos de archivo, mostramos el nombre
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: file.name
      }));
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "aplicar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          // Datos de facturación
          if (usuario.facturacion) {
            formData.append("facturacion_entidad", usuario.facturacion.entidad || "");
            formData.append("facturacion_cbu", usuario.facturacion.cbu || "");
            formData.append("facturacion_dato_fiscal", usuario.facturacion.dato_fiscal || "");
            formData.append("facturacion_porcentaje", usuario.facturacion.porcentaje || "");
            
            // Archivos de comprobantes
            if (usuario.facturacion.comprobante_afip) {
              formData.append("facturacion_comprobante_afip", usuario.facturacion.comprobante_afip);
            }
            if (usuario.facturacion.comprobante_cbu) {
              formData.append("facturacion_comprobante_cbu", usuario.facturacion.comprobante_cbu);
            }
            if (usuario.facturacion.comprobante_entidad) {
              formData.append("facturacion_comprobante_entidad", usuario.facturacion.comprobante_entidad);
            }
          }

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${usuario.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            //return navigate(`/dashboard/cupones/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "guardar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          // Datos de facturación
          if (usuario.facturacion) {
            formData.append("entidad", usuario.facturacion.entidad || "");
            formData.append("cbu", usuario.facturacion.cbu || "");
            formData.append("dato_fiscal", usuario.facturacion.dato_fiscal || "");
            formData.append("porcentaje", usuario.facturacion.porcentaje || "");
            
            // Archivos de comprobantes
            if (usuario.facturacion.comprobante_afip) {
              formData.append("facturacion_comprobante_afip", usuario.facturacion.comprobante_afip);
            }
            if (usuario.facturacion.comprobante_cbu) {
              formData.append("facturacion_comprobante_cbu", usuario.facturacion.comprobante_cbu);
            }
            if (usuario.facturacion.comprobante_entidad) {
              formData.append("facturacion_comprobante_entidad", usuario.facturacion.comprobante_entidad);
            }
          }

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${value}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            return navigate(`/dashboard/usuarios/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      //case "rol":
      case "provincia":
      case "localidad":
      case "direccion":
      case "apellido":
      case "nombre":
        {
          setUsuario({
            ...usuario,
            [e.target.name]: e.target.value
          })
        }
        break;
      case "facturacion-entidad":
      case "facturacion-cbu":
      case "facturacion-dato_fiscal":
      case "facturacion-identificador":
      case "facturacion-porcentaje":
      case "facturacion-comprobante_afip":
      case "facturacion-comprobante_cbu":
      case "facturacion-comprobante_entidad":
      case "facturacion-comprobante_identificador":
        {
          const fieldName = e.target.name.replace("facturacion-", "");
          const value = e.target.type === 'file' ? e.target.files[0] : e.target.value;
          
          // Si es un archivo, generar previsualización
          if (e.target.type === 'file' && e.target.files[0]) {
            handleFilePreview(e.target.files[0], fieldName);
          }
          
          setUsuario({
            ...usuario,
            facturacion: {
              ...usuario.facturacion,
              [fieldName]: value
            }
          })
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!usuario && id) {
       fetch(setUsuario, {}, `/usuarios/${id}`);
    }
  }, [id]);

  useEffect(() => {
    if (!provincias) {
       fetch(setProvincias, {}, `/provincias`);
    }
  }, []);

  if (!usuario || !provincias) {
    return "";
  }

  return (
    <Usuario
      data={usuario}
      provincias={provincias}
      onClick={onClick}
      onChange={onChange}
      filePreview={filePreview}
    />
  );
};

export default UsuarioController;
